import { GenericFieldFactory } from "../../Common/_generics/GenericFieldFactory";

export const ProductsSecondaryViewStore = GenericFieldFactory("PRODUCTS_SECONDARY_VIEW", null);